import React,{useState,useEffect} from 'react';
import axios from "axios";
import {Skeleton,Result} from 'antd';
import {useAxios} from "../hooks/hooks";
import AuthIFrame from "react-auth-iframe";
import {useKeycloak} from "@react-keycloak/web";
import config from "../business/config.json";
 
const PDFComponent = (props) => {
	const { keycloak,  } = useKeycloak();
	const kcToken = (keycloak?.token) ?? 'no token';
	// const [result,setResult] = useState(null);
	const [pdfURL,setPdfURL] = useState(null);
	// const base64ToBlob = (base64, type) => {
	// 	const bytes = atob(base64);
	// 	const buffer = new ArrayBuffer(bytes.length);
	// 	const view = new Uint8Array(buffer);
	// 	for (let i = 0; i < bytes.length; i++) {
	// 		view[i] = bytes.charCodeAt(i);
	// 	}
	// 	return new Blob([buffer], { type });
	// }

	const fetchPdf = async ()=>{
		console.log(props)
		try{
			// var response = await axios.current.get(props.file,{responseType: 'blob'});
			//
			// // console.log(btoa(unescape(encodeURIComponent(response.data))));
			// // console.log(base64ToBlob(btoa(unescape(encodeURIComponent(response.data))), 'application/pdf'));
			//
			// const urlObject = URL.createObjectURL(response.data);
			// console.log(urlObject)
			// var blob = new Blob([response.data], { type: 'application/pdf' });
			// console.log(URL.createObjectURL(blob))
			setPdfURL(config.api_domain + "/"+ props.file.substring(1));
			// setResult(true);
		}catch(e){
			console.log(e)
			// setResult(false);
			setPdfURL(false)
		}
	}
	useEffect( ()=> {
			fetchPdf();
	},[props.file]);
	
	if(pdfURL === null){
		return (
			<>
				<Skeleton active/>
			</>
		);
	}

	if(pdfURL === false){
		return (
			<>
				<Result
					status="404"
					title="Not Found"
    			subTitle="Sorry, this document does not exist yet."
  			/>
			</>
		);
	} else {
		return (
			<>
				{/*<embed*/}
				{/*	data={pdfURL}*/}
				{/*	id="pdf"*/}
				{/*	alt="pdf"*/}
				{/*	width="100%"*/}
				{/*	height="600px"*/}
				{/*	style={{borderStyle: "none"}}*/}
				{/*	type="application/pdf"*/}
				{/*/>*/}
				<AuthIFrame
					style={{width:"100%",height:"600px",border:"none"}}
					src={pdfURL}
					token={kcToken}
					type="application/pdf"
				>
				</AuthIFrame>
			</>
		);
	}
};

export default PDFComponent;
